import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'aym',
    fullName: 'Aymara',
    nativeName: 'Aymara',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Something Amazing is Coming",
    landing_subtitle: "ArgVoid is an app and game development studio. Stay tuned, new things are coming soon!",
    select_language: "Select Language",
    search_placeholder: "Search languages...",
    terms_title: "Terms of Service",
    policy_title: "Privacy Policy",
    cookies_title: "Cookie Policy",
    terms_content: `
        <strong>1. Acceptance of Terms</strong><br>
        By accessing ArgVoid, these Terms of Service are accepted. If these terms are not agreed to, the service should not be used.<br><br>

        <strong>2. Platform Usage</strong><br>
        ArgVoid and its applications are provided "as is" for informational and creative purposes. The service must be used only for lawful purposes.<br><br>

        <strong>3. Prohibited Conduct</strong><br>
        Exploiting site vulnerabilities, spamming, or attempting unauthorized access to the infrastructure is strictly prohibited.<br><br>

        <strong>4. Disclaimer</strong><br>
        The platform and services may be modified at any time without notice. No warranty is provided regarding the uptime or availability of the service.
    `,
    policy_content: `
        <strong>1. Information Collection</strong><br>
        The platform does not require user authentication or account creation at this time. No personal identifying information (such as names or email addresses) is actively collected from visitors.<br><br>

        <strong>2. Usage Data</strong><br>
        Basic, anonymized analytics may be collected to understand site traffic and improve the applications. This data is not linked to individual user identities.<br><br>

        <strong>3. Third-Party Services</strong><br>
        Third-party providers may be utilized for hosting and analytics services. The privacy practices of these respective providers govern the anonymous data processed on their infrastructure.<br><br>

        <strong>4. Data Security</strong><br>
        Reasonable security measures are implemented to protect the platform. However, no method of transmission over the Internet is entirely secure.<br><br>
    `,
    cookies_content: `
        <strong>1. What are Cookies and Local Storage?</strong><br>
        Cookies and browser local storage are small data files stored on the device to remember configuration preferences across visits.<br><br>

        <strong>2. Usage Purpose</strong><br>
        Browser LocalStorage is used strictly to save configuration settings, such as:<br>
        - Language preferences<br>
        - User interface configuration (e.g., layout or theme settings)<br>
        - Temporary application cache<br><br>

        <strong>3. No Tracking</strong><br>
        Cookies and local storage are not used for advertising or third-party tracking purposes. All stored data is strictly for the core functionality of the platform.<br><br>

        <strong>4. Control</strong><br>
        Browser data can be cleared at any time through the browser settings, which will reset any local configurations.
    `,
    cookie_consent_text: "We use basic cookies to ensure the website functions correctly, such as keeping your session active, saving your language preference, and other custom configurations.",
    read_policy: "Read Cookie Policy",
    support_title: "Contact Support",
    support_subject_label: "Subject",
    support_message_label: "Message",
    support_submit_button: "Send Message",
    support_hint: "Note: This will open your default email application to send the message.",
    support_success_msg: "Opening your email app...",
    support_error_msg: "Failed to send message. Please try again later.",
    explorer_title: "Explorer",
    history_title: "History",
    animation_title: "Animation",
    config_title: "Configuration",
    tool_mouse: "Select (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solid/Clear)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Adjust Brush Size",
    tool_bucket: "Fill (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Rotate (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Width",
    label_height: "Height",
    label_frames: "Number of Frames",
    label_animation: "Animation Style",
    label_background_color: "Background Color",
    label_interval: "Interval",
    tool_anim_config: "Animation Configuration",
    label_new_width: "New Width",
    label_new_height: "New Height",
    label_apply: "Apply",
    label_colors: "Colors",
    label_size: "Size",
    label_tolerance: "Tolerance",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Sequence",
    val_bounce: "Bounce",
    val_random: "Random",
    val_solid: "Solid",
    val_clear: "Clear",
    action_add_sheet: "New Sheet",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Sort",
    sort_date_old: "Oldest First",
    sort_date_new: "Newest First",
    sort_name_az: "Name (A-Z)",
    sort_name_za: "Name (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "New Project",
    modal_save_all_title: "Save All Changes",
    modal_save_all_desc: "Select the assets to save:",
    modal_save_selected: "Save Selected",
    action_saved: "Saved",
    modal_create_sprite_title: "Create New Sprite",
    modal_create_project_title: "Create New Project",
    modal_add_sheet_title: "Add New Sheet",
    modal_rename_sheet_title: "Rename Sheet",
    modal_rename_sprite_title: "Rename Sprite",
    modal_delete_sprite_title: "Delete Sprite",
    modal_delete_project_title: "Delete Project",
    modal_delete_sheet_title: "Delete Sheet",
    placeholder_sprite_name: "Name",
    placeholder_project_name: "Name",
    placeholder_sheet_name: "Name",
    placeholder_new_name: "New Name",
    action_create: "Create",
    action_add: "Add",
    action_rename: "Rename",
    action_duplicate: "Duplicate",
    action_delete: "Delete",
    action_cancel: "Cancel",
    confirm_delete_sprite: "Are you sure you want to delete this sprite?",
    confirm_delete_project: "Are you sure you want to delete this project? All sprites will be removed.",
    confirm_delete_sheet: "Are you sure you want to delete this sheet?",
    err_select_sprite: "Please select a sprite first.",
    err_select_project: "Please select a project first.",
    err_name_empty: "Name cannot be empty.",
    err_sprite_exists: "A sprite with that name already exists.",
    err_project_exists: "A project with that name already exists.",
    err_no_content: "No content to save.",
    err_no_changes: "No changes to save.",
    err_delete_last_sheet: "Cannot delete the last sheet.",
    err_extract_frames: "Could not extract any frames.",
    err_indexeddb: "Failed to save locally. Your browser may not support IndexedDB.",
    msg_upload_success: "Upload Successful: {0}",
    msg_upload_failed: "Upload Failed: {0}",
    msg_save_success: "Save successful.",
    msg_saving: "Saving...",
    msg_multi_save_result: "Saved {0} assets. {1} failures.",
    menu_title: "Menu",
    menu_save: "Save",
    menu_save_all: "Save All",
    menu_support: "Contact Support",
    label_local_storage: "Local Storage",
    label_sign_in: "Sign In",
    modal_export_title: "Export Sprite",
    label_filename: "Filename",
    label_format: "Format",
    action_export_confirm: "Export",
};

export default translations;
